import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.querySelector("main")?.scroll({ top: 0 })
  }, [pathname]);
};
